// JQ4-45 · US-AUDIT-005 — Org Admin Audit Log route
//
// Access: org_admin only (dashboard context).
// super_admin uses the super-admin.audit-log route instead.
// valet / supervisor → denied message (R-RBAC-01, R-RBAC-02).
//
// NOTE: .index.tsx suffix REQUIRED (same convention as checkin-config + tip-config routes).
// Without the .index suffix, TanStack Router treats the file as a layout component.

import { useTranslation } from '@jq4race/i18n';
import { createFileRoute } from '@tanstack/react-router';
import { ShieldOff } from 'lucide-react';

import { getCurrentSession } from '../app/auth-state';
import { PageHeader } from '../modules/app-shell/ui/PageHeader';
import { AuditLogPage } from '../modules/audit-log/ui/pages/AuditLogPage';

function AuditLogRouteComponent() {
  const session = getCurrentSession();
  const role = session?.user.role ?? '';

  // R-RBAC-01, R-RBAC-02: show denied message for unauthorized roles
  // (server is the real authority; this is a UX gate only)
  if (role !== 'org_admin') {
    return <DeniedPage />;
  }

  return <AuditLogPage />;
}

function DeniedPage() {
  const { t } = useTranslation('audit-log');
  return (
    <div className="space-y-8">
      <PageHeader eyebrow={t('page.eyebrow')} title={t('page.title')} />
      <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
        <ShieldOff className="h-10 w-10 text-jq-stone" strokeWidth={1.25} />
        <p className="text-[14px] font-medium text-jq-charcoal">
          You do not have permission to view the audit log.
        </p>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/dashboard/audit-log/')({
  component: AuditLogRouteComponent,
  staticData: {
    breadcrumb: ['Audit', 'Audit Log'],
  },
});
